module.exports = __webpack_public_path__ + "img/Veritas_island_treasure.30e6aff0.png";